import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'
import { composeStyle } from '@xhs/yam-beer/core/system/compose'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.modal', {
      mask: {
        position: 'fixed',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        overflow: 'auto',
        bg: 'rgba(0,0,0,0.6)',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        '.v-enter-from &, .v-leave-to &': {
          opacity: 0,
        },
        '.v-enter-active &, .v-leave-active &': {
          transition: 'opacity 0.24s ease',
        },
      },
      common: {
        sized: {
          width: composeStyle
            .switch('size')
            .case('s', 400)
            .case('m', 480)
            .case('l', 640)
            .case('xl', 800)
            .default(composeStyle.var('size', '_VAR_')),
        },
      },
      container: {
        borderRadius: 8,
        bg: 'white',
        fontSize: 14,
        color: 'body',
        boxShadow: 'level4',
        '.v-enter-from &, .v-leave-to &': {
          opacity: 0,
          transform: 'scale(0.8)',
        },
        '.v-enter-active &, .v-leave-active &': {
          transition: 'all 0.24s',
        },
      },
      header: composeStyle
        .switch('type')
        .case('dialog', {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pt: 11,
          px: 24,
          mb: 24,
        })
        .default({
          fontSize: 16,
          fontWeight: 'medium',
          px: 24,
          pb: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }),
      content: {
        px: 24,
      },
      footer: composeStyle
        .switch('type')
        .case('dialog', {
          mt: 24,
          px: 24,
          textAlign: 'center',
        })
        .default({
          mt: 32,
          px: 24,
          textAlign: composeStyle.var('footerPosition', '_VAR_'),
        }),
    }),
  ]
}

export const sizeMap = {
  s: 400,
  m: 480,
  l: 640,
  xl: 800,
}
